<div class="flex flex-col gap-y-2" *transloco="let t">
  @if (modalData.asin && modalData.marketplace) {
    <app-product-view [asin]="modalData.asin" [marketplace]="modalData.marketplace" class="my-2" />
  }
  @for (profitLine of profitLines; track $index) {
    @if (profitLine.type === "category" && profitLine.value) {
      <div class="rounded-md border border-gray-300">
        <div class="flex flex-col gap-x-2 px-3 py-1">
          @for (item of profitLine.lines; track $index) {
            <app-profit-details-line [profitLine]="item" />
          }
        </div>
        <div class="rounded-b-md border-t border-gray-300 bg-gray-100 px-3 py-1">
          <app-profit-details-line [profitLine]="profitLine" />
        </div>
      </div>
    } @else if (profitLine.value) {
      <div class="rounded-md border border-gray-300 px-3 py-1">
        <app-profit-details-line [profitLine]="profitLine" />
      </div>
    }
  }
</div>
